export const FONTSIZE = 'FONT-SIZE';